export default "__VITE_ASSET__BfvD2yhF__"